import { useCallback, useEffect, useRef, useState } from "react"
import useRefreshToken from "../../../../Hooks/usegenerateToken"
import SlideUpWrapper from "../../../../components/Transitions/SlideUpWrapper"
import Breadcrumb from "../../../../components/Verifier/breadcrumb/BreadCrumb"
import PreviewPDF from "../../../../components/pdfPreview/Previewpdf"
import { BASE_URL, COPY_DOCUMENT_TEMPLATE, GET_TEMPLATE_DETAILS, UPDATE_DOCUMENT_NAME, USER_TOKEN } from "../../../../Utils/constant"
import { useLocation, useNavigate } from "react-router-dom"
import IssuerNavigator from "../../../../components/DashBoard/IssuerNavigator"
import { Delay, setDate } from "../../../../Utils/helper"

import API from '../../../../ApiConfig'
import styles from '../../ExternalDash/Verifier/VerifyUsers.module.css'
import tagmap from '../../tagMapping.module.css'
import cogoToast from "cogo-toast-react-17-fix"
import ReactPortalModal from "../../../../components/ReactPortalModal"
import { BUTTONS, MESSAGE } from "../../../../Utils/Strings"

export const DocumentDetails = ({ ISSUER_ID, handleStep, doc, setDoc }) => {
    const [loading, setLoading] = useState(false)
    const [documentData, setDocumentData] = useState([])
    useRefreshToken(BASE_URL + USER_TOKEN)
    const navigate = useNavigate()

    useEffect(() => {
        getdocumentData()
    }, [])

    function getdocumentData() {
        API.get(`${GET_TEMPLATE_DETAILS}${doc.doc_type}/${doc.id}`)
            .then(res => {
                setLoading(false)
                if (res.status === 200)
                    setDocumentData(res.data.data)

            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err.message)
            })
    }

    const [preview, setPreview] = useState(false)
    const template_name = useRef(null)
    // const [nextstep, setNextStep] = useState(null)

    const [error, seterror] = useState(null)
    const [submitting, setsubmitting] = useState(false)

    const onSubmit = (nextstep) => {
        var date = new Date();
        // if (template_name.current.value) {
        setsubmitting(true)
        let payload = {
            template_name: template_name?.current?.value || doc.doc_name + date.getSeconds().toString() + date.getMilliseconds().toString(),
            doc_state: nextstep?.link ? 'edit' : 'issue',
            master_template_id: doc.id,
            issuer_id: ISSUER_ID
        }
        API.post(COPY_DOCUMENT_TEMPLATE, payload)
            .then(res => {
                if (res.status === 200) {
                    setDoc(res.data.data)
                    cogoToast.success('Document created')
                    Delay(1)
                    nextstep.link ? navigate(`/create/${res.data.data.id}/Mapping`) : handleStep(3)
                }
            })
            .catch(err => {
                setLoading(false)
                cogoToast.error(err.message)
                // seterror(err.message)
            })
            .finally(() => setsubmitting(false))
        // }
        // else {
        //     seterror('Enter some Value')
        // }
    }

    const DocPreview = () => {
        return (
            <div>
                <div className='topTitleBar' >
                    <div style={{ width: '95%' }}>
                        <div>New Template Name</div>
                        <input placeholder="Start Typing" maxLength='50' ref={template_name} className="inputText1" style={{ border: '1px solid var(--gray-300)', borderRadius: '0.3rem', padding: '10px', marginTop: '1rem' }}></input>
                        {error ? <span className="subtext">{error}</span> : null}
                    </div>
                </div>
                <hr></hr>
                <div className="custom-td navItemContainer">
                    <button className="btn btn-primary" onClick={submitting ? null : onSubmit}>{submitting ? BUTTONS.SAVING : BUTTONS.SUBMIT}</button>
                </div>
            </div>
        )
    }

    const useTemplate = () => {

        const handleNavigate = (nextstep) => {
            if (doc.doc_type == 1) {
                nextstep.link ? navigate(`/create/${nextstep.link}/Mapping`) : handleStep(nextstep.step)
            }
            else {
                if (nextstep.link) {
                    setPreview(true)

                }
                else {
                    // setNextStep(nextstep)
                    onSubmit(nextstep)
                }
            }
        }
        return (
            <div className="navItemContainer">
                {doc.document_state == "Issued" ? null : <button disabled={submitting} className="btn btn-secondary" onClick={e => handleNavigate({ link: doc.id })} style={{ width: '10rem', border: '1px solid var(--gray-200)' }}>Customize</button>}
                <button disabled={submitting} className="btn btn-primary" onClick={e => handleNavigate({ step: 3 })} style={{ width: '10rem' }}>Use this Template</button>
            </div>
        )
    }

    const ShowTags = useCallback(() => {
        const showtags = (tags) => {
            let n = tags.length
            if (n > 0) {
                return (
                    <span className={tagmap.supportingDocuments} title={tags.map(e => e.master_document_name).join(", ")}>
                        {tags[0].master_document_name}{n - 1 != 0 ? (' +' + (n - 1)) : null}
                    </span>
                )
            }
            return (
                <span className={tagmap.notRequired}>Not required</span>
            )
        }
        if (loading) {
            return (
                [...Array(2)].map((_, index) => (
                    <tr className="custom-tr">
                        <td className="custom-td"><div className="shimmer"></div></td>
                        <td className="custom-td"><div className="shimmer"></div></td>
                        <td className="custom-td"><div className="shimmer"></div></td>
                    </tr>
                ))
            )
        }
        else if (documentData?.details && documentData.details.length > 0) {
            return (
                documentData.details.map((val, index) => (
                    <tr className="custom-tr" key={val.id} style={loading ? null : { animationDelay: `${index * 0.1}s` }}>
                        <td className="custom-td">{val.variable}</td>
                        <td className="custom-td">{val.tag_name}</td>
                        <td className="custom-td">{showtags(val.supporting_docs)}</td>

                        {/* <td className="custom-td">{val.supporting_docs.length > 0 ? val.supporting_docs.map(item => <div className={"btn btn-secondary custom-th " + styles.matchDoc}>{item.master_document_name}</div>) : <div className={"btn btn-secondary custom-th " + styles.matchDoc}>N/A</div>}</td> */}
                    </tr>
                ))
            )
        }

    }, [documentData])

    const [doc_name, setDoc_name] = useState(doc?.doc_name || '')
    const [Edit, setEdit] = useState(false)
    const handleDocNameChange = (value) => {
        if (isNaN(value) && (value.length > 1 || value.length < 100)) {
            API.put(UPDATE_DOCUMENT_NAME, {
                "doc_id": parseInt(doc.id),
                "doc_name": value
            }).then(data => {
                cogoToast.info("Document name updated to " + value)
            }).catch(err => {
                cogoToast.error("cant set the name to " + value)
            }).finally(() => setEdit(false))
        }
        else {
            if (value.length == 0)
                value = "Untitled"
            cogoToast.error("cant set the name to " + value)
        }
    };


    return (

        <div style={{width:"100%"}}>
            <Breadcrumb pos={1} title={'Issue Document'} category={'issuer'} />
            <SlideUpWrapper>
                <IssuerNavigator
                    title={doc.doc_name}
                    handlestep={handleStep}
                    step={1}
                    actions={useTemplate}
                />
                <div className='issuer-container container justify-content-flex-start navItemContainer'>
                    <div style={{ width: '30rem', overflow: 'hidden' }}>
                        {doc && <PreviewPDF doc_id={doc.id} load={loading} setLoading={setLoading} type={'pdf'} isMaster={!doc.doc_type} />}
                    </div>
                    <div className="w-50">
                        {doc.doc_type ?
                            Edit ? <div style={{ display: "flex", alignItems: "center", alignContent: "center", justifyContent: " space-between" }}>
                                <input className="inputText1" style={{ width: '10rem', border: '1px solid var(--gray-300)', borderRadius: '0.3rem', padding: '10px' }} value={doc_name || ''} onChange={(e) => setDoc_name(e.target.value)} />
                                <button className="btn btn-secondary" onClick={() => setEdit(false)}>CANCEL</button>
                                <button className="btn btn-primary" onClick={() => handleDocNameChange(doc_name)} >Update</button>
                            </div> : <div style={{ display: "flex", alignItems: "center", alignContent: "center", justifyContent: " space-between" }}>

                                <h1 className="header-title">
                                    {doc_name}
                                </h1>
                                <button className="btn btn-primary" onClick={() => setEdit(true)}>Edit Name</button>
                            </div>
                            : <h1 className="header-title">
                                {doc_name}
                            </h1>}
                        <div className="container justify-content-flex-start navItemContainer">
                            <div className="issuer-label-wrapper">
                                <span>Created on</span>
                                <span className="issuer-label">{setDate(doc.updated_at)}</span>
                            </div>
                            <div className="issuer-label-wrapper">
                                <span>Document Type</span>
                                <span className="issuer-label">{doc.master_doc_name}</span>
                            </div>
                        </div>
                        <div className={styles.searchBox}>
                            <span className="header-title" style={{ margin: '1rem' }}>
                                Dynamic Tags
                            </span>
                            <table className="custom-table">
                                <tr className='credentials-header'>
                                    <td className="custom-th">Variable</td>
                                    <td className="custom-th">Tags</td>
                                    <td className="custom-th">Match Document</td>
                                </tr>

                                <ShowTags />
                            </table>
                        </div>
                    </div>
                </div>

                <ReactPortalModal title="Create new Template" isOpen={preview} blockOutsideClick onClose={e => setPreview(null)}>
                    <DocPreview />
                </ReactPortalModal>
            </SlideUpWrapper>
        </div>
    )
}
